import { FanActivityStatus } from '../../../enums';
import { SortedPaginationQueryV2 } from '../../../validators';
import { UserStatsEntity } from './userStats.entity';

/**
 * "Declined" is not an interaction: it is the live position flag
 * `seatsRequestStatus === 'DECLINED'`, modelled as a synthetic cohort key.
 */
export const DECLINED_COHORT = 'DECLINED' as const;

export type DropOffCohort =
  | FanActivityStatus.LEAVE_WL
  | FanActivityStatus.REJECT_SEATS
  | FanActivityStatus.SEATS_EXPIRE
  | FanActivityStatus.FAN_CANCEL_SEATS
  | FanActivityStatus.CANCEL_SEATS
  | typeof DECLINED_COHORT;

export const DROP_OFF_COHORTS: DropOffCohort[] = [
  FanActivityStatus.LEAVE_WL,
  FanActivityStatus.REJECT_SEATS,
  FanActivityStatus.SEATS_EXPIRE,
  FanActivityStatus.FAN_CANCEL_SEATS,
  FanActivityStatus.CANCEL_SEATS,
  DECLINED_COHORT,
];

/** Sort keys the server accepts, sent as `<key>:ASC|DESC`. Default is `exitDate:DESC`. */
export const DROP_OFF_SORT_KEYS = [
  'exitDate',
  'userStats.nrOfWaitinglistsJoined',
  'userStats.won',
  'userStats.abandoned',
] as const;

export type DropOffSortKey = (typeof DROP_OFF_SORT_KEYS)[number];

/** One departed fan. Archived users come back with null names and email. */
export interface DropOffEntity {
  fanId: string;
  firstName: string | null;
  lastName: string | null;
  fanEmail: string | null;
  type: DropOffCohort;
  /** ISO date; null for DECLINED, which has no exit event. */
  exitDate: string | null;
  numberOfSeats: number;
  userStats: UserStatsEntity;
  /** Badge ids; labels and colours come from the fan-group badge catalogue. */
  tags: string[];
}

export type DropOffQuery = SortedPaginationQueryV2 & {
  /** Omitted means no filter; `[]` returns no rows. */
  cohorts?: DropOffCohort[];
};
